export const DEFAULT_NUMBER_TYPE_VALUE = -1
